








































import { Component, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";

// Types
import { IClientAuthProviderMethods } from "@/models/providers/clientAuth";

@Component({
  computed: {
    ...mapGetters({
      isGuestAuthenticated: "auth/guest/isAuthenticated"
    })
  },
  components: {
    "client-auth-provider": () =>
      import("@/components/app/global/auth/clientAuth/clientAuthProvider.vue"),
    "client-auth-register-fields": () =>
      import(
        "@/components/app/global/auth/clientAuth/clientAuthRegisterFields.vue"
      )
  }
})
export default class ClientRegistrationForm extends Mixins(
  HasValidation,
  Context
) {
  // Map getters

  public isGuestAuthenticated!: boolean;

  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    clientAuthRegisterFields: HTMLFormElement;
  };

  // Variables

  public isLoading = true;
  public isProcessing = false;
  public isSuccess = false;

  // Life cycle methods

  public created() {
    if (this.isGuestAuthenticated) {
      this.isLoading = false;
      return;
    }

    this.$store.dispatch("auth/guest/createToken");
  }

  // Methods

  public async validateBeforeSubmit(
    clientAuthMethods: IClientAuthProviderMethods
  ) {
    try {
      this.isProcessing = true;

      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      await this.$refs.clientAuthRegisterFields.uploadCustomImages(true);
      await clientAuthMethods.registerClient();

      this.isSuccess = true;
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.registration_successful")
      });
    } catch (error) {
      await this.$refs.clientAuthRegisterFields.generateToken();
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  // Computed

  public get disableSubmitButton() {
    if (!this.hasErrors) {
      return false;
    }
    const errors = this.$_.cloneDeep(this.validationErrors);
    delete errors["recaptcha_token"];
    return this.$_.isEmpty(errors);
  }
}
